/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response object for an institute email
 * @export
 * @interface InstituteEmail
 */
export interface InstituteEmail {
    /**
     * Unique identifier of the institute email
     * @type {string}
     * @memberof InstituteEmail
     */
    instituteEmailId?: string;
    /**
     * email of the institute
     * @type {string}
     * @memberof InstituteEmail
     */
    email?: string;
}

/**
 * Check if a given object implements the InstituteEmail interface.
 */
export function instanceOfInstituteEmail(value: object): value is InstituteEmail {
    return true;
}

export function InstituteEmailFromJSON(json: any): InstituteEmail {
    return InstituteEmailFromJSONTyped(json, false);
}

export function InstituteEmailFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstituteEmail {
    if (json == null) {
        return json;
    }
    return {
        
        'instituteEmailId': json['instituteEmailId'] == null ? undefined : json['instituteEmailId'],
        'email': json['email'] == null ? undefined : json['email'],
    };
}

export function InstituteEmailToJSON(json: any): InstituteEmail {
    return InstituteEmailToJSONTyped(json, false);
}

export function InstituteEmailToJSONTyped(value?: InstituteEmail | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'instituteEmailId': value['instituteEmailId'],
        'email': value['email'],
    };
}

